import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, catchError, finalize, tap, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { ModalContentService } from '../modal-content/modal-content.service';
import { ModalContentTypes } from '../constants/modal-content-types';
import { DateTime } from 'luxon';
import { LocalStorageService } from '../local-storage.service';
import { LOCALSTORAGE_KEYS } from '../constants/databases';
import { Session } from '../types/session.type';
import { FirebaseCrudService } from '../firebase-crud.service';
import { environment } from '../../../environments/environment';
import { LoadingService } from '../loading.service';
import { preventErrorForLog, redactErrorLogPayload } from '../common/error-log.util';

export function httpInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown> | any> {

  const modalService = inject(ModalContentService);
  const localStorageService = inject(LocalStorageService);
  const firebaseCrudService = inject(FirebaseCrudService);
  const loadingService = inject(LoadingService);

  if (req.method !== 'GET' || req.url.includes('order'))
    loadingService.validateEndPoint(req.url);

  return next(req).pipe(
    finalize(() => {
      if (loadingService.queue.has(req.url)) {
        loadingService.close(req.url);
      }
    }),
    catchError((error) => validateError(req, error, modalService, localStorageService, firebaseCrudService)),
    tap(event => {
      if (event && event.type === HttpEventType.Response) {
        if (!environment.production)
          console.log(req.url, 'returned a response with status', event.status);
      }
    }));
}

function validateError(
  req: HttpRequest<unknown>,
  error: HttpErrorResponse,
  modalService: any,
  localStorageService: LocalStorageService,
  firebaseCrudService: FirebaseCrudService
): Observable<HttpEvent<any>> {

  const preventErrorLog = preventErrorForLog(error.status, error.url);
  if (!preventErrorLog) {
    sendErrorToFirebase(req, error, localStorageService, firebaseCrudService);
  }

  switch (error.status) {
    case 444:
      modalService.openModal(ModalContentTypes.ACCOUNT_SUSPENDED, { closeable: false, closeOthers: true });
      break;
    default:
      break;
  }

  return throwError(() => error);
}


function sendErrorToFirebase(
  httpRequest: HttpRequest<any>,
  error: HttpErrorResponse,
  localStorageService: LocalStorageService,
  firebaseCrudService: FirebaseCrudService
) {
  try {
    const currentUTCDateTime = DateTime.utc();
    const currentDateArray = currentUTCDateTime.toString().split('T');
    const currentStringDate = currentDateArray[0];
    const currentStringTime = currentDateArray[1].split('.')[0];



    let errorLog: any = {
      payload: redactErrorLogPayload(httpRequest.body),
      method: httpRequest.method,
      statusCode: error.status,
      statusText: error.statusText,
      url: error.url,
      timestamp: currentUTCDateTime.toMillis(),
      createdAt: `${currentStringDate} ${currentStringTime}`,
      createdAtDate: currentStringDate,
      createdAtTime: currentStringTime,
      message1: error?.error?.message || 'Unknow error',
      message2: error?.message || 'Unknow error',
      errorName: error?.name || null,
      errorType: error?.type || null,
    }

    // Session data:
    const storedSession: Session | null = localStorageService.get(LOCALSTORAGE_KEYS.SESSION);
    if (storedSession) {
      errorLog.clientId = storedSession.accountInfo.id;
    }

    firebaseCrudService.addErrorLog(errorLog);
  } catch (error) {
    console.log('Error trying to send data to Firebase: ', error);
  }
}
